<template>
  <div class="page login-page">
    <div class="login-content">
      <van-nav-bar class="nav-bar" :border="false" placeholder>
        <template #left>
          <van-icon name="arrow-left" color="#fff" size="24" @click="back()" />
        </template>
      </van-nav-bar>

      <div class="form-wrap">
        <div class="form-title">{{ $t("auth.register") }}</div>

        <div class="form-fields">
          <van-field
            v-model="username"
            clearable
            input-align="center"
            class="input-large"
            :placeholder="$t('auth.username_place')"
          />

          <van-field
            v-model="password"
            :type="passwordType"
            input-align="center"
            class="input-large"
            :placeholder="$t('auth.pwd_place')"
          >
            <template #right-icon>
              <van-icon
                :name="passwordType === 'password' ? 'closed-eye' : 'eye-o'"
                @click="switchPasswordType"
              />
            </template>
          </van-field>

          <van-field
            v-model="code"
            clearable
            input-align="center"
            class="input-large"
            :placeholder="$t('auth.invite_code_place')"
          />

          <van-button 
            class="btn-large-primary" 
            :loading="isSubmitting" 
            loading-type="spinner"
            @click="doRegister()"
          >
            {{ $t("auth.register") }}
          </van-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      checked: true,
      username: '',
      code: '',
      lang: 'en_us',
      password: '',
      passwordType: 'password',
      // password1: '',  // <-- 已移除提款密码字段
      isSubmitting: false, // 按钮加载状态
    };
  },
  mounted() {
    this.lang = localStorage.getItem("lang") || 'es_spa';
  },
  created() {
    if (localStorage.getItem('token')) {
      return window.history.back();
    }
  },
  methods: {
    switchPasswordType() {
      this.passwordType = this.passwordType === 'password' ? 'text' : 'password';
    },
    back() {
      return window.history.back();
    },
    doRegister() {
      if (!this.username) {
        this.$toast.fail(this.$t("auth.username_place"));
        return false;
      }
      if (!this.password) {
        this.$toast.fail(this.$t("auth.pwd_place"));
        return false;
      }
      if (!this.code) {
        this.$toast.fail(this.$t("auth.invite_code_place"));
        return false;
      }

      this.isSubmitting = true; // 开启加载动画

      this.$http({
        method: 'post',
        url: 'member_register',
        data: {
          username: this.username,
          password: this.password,
          // password1: this.password1, <-- 已移除提款密码参数
          code: this.code,
          lang: this.lang
        }
      }).then(res => {
        this.isSubmitting = false; // 关闭加载动画
        if (res.code === 200) {
          this.$toast.success(res.msg);
          localStorage.setItem('token', res.data);
          this.$router.push("Mine");
        } else {
          this.$toast.fail(res.msg);
        }
      }).catch(() => {
        this.isSubmitting = false;
        this.$toast.fail("网络请求失败，请稍后重试");
      });
    }
  }
};
</script>

<style lang="less" scoped>
.login-page {
  min-height: 100vh;
  background: url('/img/login/login.png') no-repeat center center;
  background-size: cover;
}

.login-content {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}

.nav-bar {
  background: transparent !important;
  ::v-deep .van-nav-bar__content {
    height: 60px;
  }
}

.form-wrap {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: flex-start; 
  /* 因为少了一个输入框，调整回和登录页一样的 22vh，保持页面统一 */
  padding: 22vh 24px 0; 
}

.form-title {
  font-size: 26px;
  font-weight: bold;
  color: #ffffff; 
  text-align: center;
  margin-bottom: 24px;
  letter-spacing: 1px;
  text-shadow: 0 2px 4px rgba(0,0,0,0.5); 
}

.form-fields {
  width: 100%;
  max-width: 440px; 
  margin: 0 auto;
}

/* 放大版的深色半透明输入框 */
.input-large {
  background: rgba(45, 45, 60, 0.75) !important;
  border-radius: 60px; 
  margin-bottom: 20px; 
  padding: 16px 24px; 
  border: 1px solid rgba(255, 255, 255, 0.08); 
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15); 
  
  ::v-deep .van-field__control {
    font-size: 16px; 
    color: #ffffff; 
  }

  ::v-deep .van-field__control::placeholder {
    color: #a0a0ab; 
  }

  ::v-deep .van-field__right-icon {
    position: absolute;
    right: 24px;
    .van-icon {
      font-size: 24px; 
      color: #7d7d9f; 
    }
  }
}

/* 放大版的按钮 */
.btn-large-primary {
  width: 100%;
  height: 54px; 
  border-radius: 60px;
  background: #5b6cf2; 
  color: #ffffff;
  border: none;
  font-size: 18px; 
  font-weight: 600;
  margin-top: 16px;
  margin-bottom: 24px;
  box-shadow: 0 4px 15px rgba(91, 108, 242, 0.4);
  transition: all 0.3s ease;
  
  &:active { 
    opacity: 0.85;
    transform: scale(0.98);
  }
}
</style>